import AspectRatioBox from "./AspectRatioBox.mjs";
export * from "./AspectRatioBox.mjs";
export * from "@ingka/aspect-ratio-box-shared/ratios";
var lib_default = AspectRatioBox;
export {
  lib_default as default
};
